if (!customElements.get('image-comparison')) {
  customElements.define(
    'image-comparison',
    class ImageComparison extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector('button');
        this.isHorizontal = this.dataset.direction === 'horizontal';

        this.startDrag = this.onStartDrag.bind(this);
        this.drag = this.onDrag.bind(this);
        this.stopDrag = this.onStopDrag.bind(this);

        this.init();

        if (!FoxTheme.config.motionReduced) {
          FoxTheme.Motion.inView(this.querySelector('.image-comparison__animation-trigger'), this.animation.bind(this));
        }
      }

      init() {
        this.buttonIcon = this.button.querySelector('span');
        this.offset = this.buttonIcon ? this.buttonIcon.offsetWidth / 2 : 20;

        this.button.addEventListener('touchstart', this.startDrag);
        this.button.addEventListener('mousedown', this.startDrag);
      }

      animation() {
        this.setAttribute('is-visible', '');
        this.classList.add('is-animating');
        setTimeout(() => {
          this.classList.remove('is-animating');
        }, 1e3);
      }

      onStartDrag(e) {
        e.preventDefault();
        document.body.classList.add('body-no-scrollbar');
        this.classList.add('is-dragging');

        if (e.type === 'mousedown') {
          document.addEventListener('mousemove', this.drag);
          document.addEventListener('mouseup', this.stopDrag);
        } else if (e.type === 'touchstart') {
          document.addEventListener('touchmove', this.drag);
          document.addEventListener('touchend', this.stopDrag);
        }
      }

      onStopDrag() {
        document.body.classList.remove('body-no-scrollbar');
        this.classList.remove('is-dragging');

        document.removeEventListener('mousemove', this.drag);
        document.removeEventListener('mouseup', this.stopDrag);

        document.removeEventListener('touchmove', this.drag);
        document.removeEventListener('touchend', this.stopDrag);
      }

      onDrag(e) {
        const event = (e.touches && e.touches[0]) || e;
        let x, distance;
        if (this.isHorizontal) {
          x = event.pageX - this.offsetLeft;
          distance = this.clientWidth;

          if (FoxTheme.config.isRTL) {
            x = distance - x; // Reverse the x position for RTL
          }
        } else {
          x = event.pageY - this.offsetTop;
          distance = this.clientHeight;
        }

        const max = distance - this.offset;
        const min = this.offset;
        const mouseX = Math.max(min, Math.min(x, max));
        const mousePercent = (mouseX * 100) / distance;
        this.style.setProperty('--percent', mousePercent + '%');
      }
    }
  );
}

document.addEventListener("DOMContentLoaded", () => {

    const section = document.querySelector(".section--image-comparison");
    const popup = document.getElementById("hoverProduct");

    if (!section || !popup) return;

    let mouseX = 0;
    let mouseY = 0;

    let currentX = 0;
    let currentY = 0;

    let visible = false;
    let popupHovered = false;
    let frozen = false;

    section.addEventListener("mouseenter", () => {
        visible = true;
        popup.style.opacity = "1";
        popup.style.visibility = "visible";
    });

    section.addEventListener("mouseleave", () => {

        if (!popupHovered) {
            visible = false;
            frozen = false;

            popup.style.opacity = "0";
            popup.style.visibility = "hidden";
        }

    });

    section.addEventListener("mousemove", (e) => {
        mouseX = e.clientX;
        mouseY = e.clientY;
    });

    popup.addEventListener("mouseenter", () => {
        popupHovered = true;
        frozen = true;
    });

    popup.addEventListener("mouseleave", () => {
        popupHovered = false;
        frozen = false;

        if (!visible) {
            popup.style.opacity = "0";
            popup.style.visibility = "hidden";
        }
    });

    function animate() {

        if (visible && !popupHovered) {

            const popupWidth = popup.offsetWidth;
            const popupHeight = popup.offsetHeight;

            let targetX = mouseX + 40;
            let targetY = mouseY + 30;

            if (targetX + popupWidth > window.innerWidth - 20) {
                targetX = mouseX - popupWidth - 40;
            }

            if (targetY + popupHeight > window.innerHeight - 20) {
                targetY = mouseY - popupHeight - 30;
            }

            targetX = Math.max(20, targetX);
            targetY = Math.max(20, targetY);

            const centerX = currentX + popupWidth / 2;
            const centerY = currentY + popupHeight / 2;

            const distance = Math.hypot(
                mouseX - centerX,
                mouseY - centerY
            );

            // Freeze when cursor gets close
            if (distance < 120) {
                frozen = true;
            }

            // Unfreeze when cursor moves away again
            if (distance > 220) {
                frozen = false;
            }

            if (!frozen) {
                currentX += (targetX - currentX) * 0.15;
                currentY += (targetY - currentY) * 0.15;
            }

            popup.style.left = currentX + "px";
            popup.style.top = currentY + "px";
        }

        requestAnimationFrame(animate);
    }

    animate();

});